"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16VehicleEbikeFill = function Svg16VehicleEbikeFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M19 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM17 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM10 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.793 8.293a1 1 0 0 1 1.414 0l2.5 2.5a1 1 0 0 1-1.414 1.414L13.5 10.414l-1.887 1.888 1.402.84a1 1 0 0 1 .466 1.054l-.5 2.5a1 1 0 0 1-1.962-.392l.362-1.81-1.896-1.136a1 1 0 0 1-.192-1.565l3.5-3.5zM10.751 5.357a.375.375 0 0 1-.048.47l-1.61 1.61 1.047 1.048a.375.375 0 0 1-.128.614l-4.313 1.688a.375.375 0 0 1-.402-.615l1.61-1.61L5.86 7.516a.375.375 0 0 1 .128-.614l4.313-1.688a.375.375 0 0 1 .45.144z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16VehicleEbikeFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16VehicleEbikeFill;
exports.default = _default;